import { Directive, forwardRef, Injectable, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[greaterThan][formControl]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => GreaterThanDirective),
            multi: true,
        },
    ],
})
@Injectable({
    providedIn: 'root',
})
export class GreaterThanDirective implements Validator
{
    @Input()
    public greaterThan: number;

    public validator(mustExceedValue: number) {
        return function (control: AbstractControl) {
            return control.value !== null &&
            control.value > mustExceedValue
                    ? null
                    : {greaterThan: 'Amount must be greater than ' + mustExceedValue + '.'};
        };
    }

    public validate(control: AbstractControl) {
        return this.validator(this.greaterThan);
    }
}
